import type { ReactNode } from 'react';
import classes from '../typography/typography.module.css';

interface PageTitleProps {
  children: ReactNode;
}

export const PageTitle = (props: PageTitleProps) => <div className={classes.H1}>{props.children}</div>;
